import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

// Legal boilerplate shared by /legal/terminos and /legal/privacidad.
// Wraps the doc in a clean, readable "editorial" layout.
export function LegalShell({ eyebrow, title, updated, children }) {
  return (
    <main className="min-h-screen bg-[#f5f2ea] text-neutral-900" data-testid="legal-page">
      <header className="border-b border-black/10 bg-[#fefaf1] sticky top-0 z-10">
        <div className="max-w-3xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 text-sm text-neutral-700 hover:text-black" data-testid="legal-back">
            <ArrowLeft size={14} /> <span className="font-mono uppercase tracking-widest text-[10px]">Volver</span>
          </Link>
          <span className="font-display text-lg tracking-tighter">CHALANN</span>
        </div>
      </header>
      <article className="max-w-3xl mx-auto px-6 md:px-10 py-12 md:py-16">
        <p className="font-mono text-[10px] tracking-[0.3em] text-neutral-500 uppercase">{eyebrow}</p>
        <h1 className="font-display text-4xl md:text-6xl tracking-tighter leading-[0.95] mt-2 mb-3">{title}</h1>
        {updated && (
          <p className="font-mono text-[11px] tracking-widest text-neutral-500 mb-8">Última actualización: {updated}</p>
        )}
        <div className="prose prose-neutral max-w-none prose-headings:font-display prose-headings:tracking-tighter prose-h2:text-2xl prose-h2:mt-10 prose-h3:text-lg prose-p:text-neutral-800 prose-p:leading-relaxed prose-li:text-neutral-800">
          {children}
        </div>
        <div className="mt-16 pt-8 border-t border-black/10 grid grid-cols-1 md:grid-cols-2 gap-6 text-sm text-neutral-700">
          <div>
            <p className="font-mono text-[10px] tracking-widest text-neutral-500 uppercase mb-1">Responsable</p>
            <p className="font-display text-lg tracking-tight">MARKETING DE INTELIGENCIA ARTIFICIAL S. de R.L. de C.V.</p>
            <p>Av. Américas 1545, Colonia Providencia, Guadalajara, Jalisco, México.</p>
          </div>
          <div>
            <p className="font-mono text-[10px] tracking-widest text-neutral-500 uppercase mb-1">Contacto</p>
            <p>Tel: <a className="underline" href="tel:+523342802102">33 4280 2102</a></p>
            <p>Marca: <span className="font-display tracking-tight">CHALANN</span> · POS por voz</p>
          </div>
        </div>
      </article>
    </main>
  );
}
